module.exports = __webpack_public_path__ + "static/media/image_3.4156215d.png";